import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2 as DocumentNumberRange,
  FormField
} from '@/components/custom/erp';

import { Label } from '@/components/ui/label';

const BasicInfoTab = () => {
  return (
    <div className='space-y-2 p-4'>
      {/* Date Range Fields */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày nhập từ/đến</Label>
        <div>
          <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
        </div>
      </div>

      {/* Số chứng từ từ/đến */}
      <div className='flex items-center'>
        <DocumentNumberRange fromName='so_ct1' toName='so_ct2' labelClassName='w-40' />
      </div>
    </div>
  );
};

export default BasicInfoTab;
